/* eslint-disable arrow-body-style */
import React, { useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import { components } from 'react-select';

import styles from './Select.module.scss';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { filterPlantName } from 'src/redux/features';
import { isObjectEmpty } from 'src/constants/utils';
import { colors } from 'src/assets/scss/partials/colors';

export const Select = ({
	label,
	options,
	selectClassName,
	selectName,
	maxMenuHeight = 160,
	onChange,
	isLoading,
	title,
	TitleHeader,
	...props
}) => {
	const dispatch = useDispatch();
	const selectedOption = useSelector((state) => state.allPlants?.plantName);
	const defaultValue = useSelector((state) => state.allPlants.plants);

	const DropdownIndicator = (props) => {
		return (
			<components.DropdownIndicator {...props}>
				{TitleHeader ? null : (
					<svg
						width="24"
						height="25"
						viewBox="0 0 24 25"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="arrow_drop_down_FILL0_wght400_GRAD0_opsz24 (2) 1">
							<path
								id="Vector"
								d="M12 15.5L7 10.5H17L12 15.5Z"
								fill="#757575"
							/>
						</g>
					</svg>
				)}
			</components.DropdownIndicator>
		);
	};

	return (
		<div {...props}>
			{label}
			<ReactSelect
				isSearchable={false}
				isLoading={isLoading}
				options={options}
				defaultValue={
					!isObjectEmpty(selectedOption) ? selectedOption : defaultValue[0]
				}
				className={clsx(styles.select, selectClassName, {
					[styles.titleHeaderselect]: !TitleHeader,
				})}
				classNamePrefix={`select-${selectName}`}
				maxMenuHeight={maxMenuHeight}
				components={{ DropdownIndicator }}
				styles={{
					menuList: (provided) => ({
						...provided,
						'&::-webkit-scrollbar': {
							width: '4px !important',
							height: '6px',
							display: 'block !important',
							background: 'none',
						},
						'&::-webkit-scrollbar-track': {
							background: 'none',
						},
						'&::-webkit-scrollbar-thumb': {
							background: colors.light_gray,
						},
						'&::-webkit-scrollbar-thumb:hover': {
							background: '#6e6a6a',
						},
					}),
					control: (provided) => ({
						...provided,
						height: '100%',
						border: '1px solid rgba(112, 112, 112, 0.50);',
					}),
					dropdownIndicator: (provided) => ({
						...provided,
						width: '30px',
						padding: '0',
					}),
					indicatorSeparator: (provided) =>
						!TitleHeader
							? null
							: {
									...provided,
									backgroundColor: '#E0E0E0',
									alignSelf: 'center',
									height: '80%',
									marginRight: 5,
							  },
					singleValue: (provided) => ({
						...provided,
						color: '#000',
						fontWeight: 700,
						fontSize: '14px',
						padding: !TitleHeader ? null : '0px 31px 0px 2px',
					}),
					indicatorsContainer: (provided) => ({
						...provided,
						color: colors.light_gray,
					}),
				}}
				onChange={(e) => {
					onChange(e);
					dispatch(filterPlantName(e));
				}}
			/>
		</div>
	);
};

Select.propTypes = {
	label: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.any.isRequired,
		})
	),
	selectClassName: PropTypes.string,
	selectName: PropTypes.string,
	maxMenuHeight: PropTypes.number,
	onChange: PropTypes.func,
	isLoading: PropTypes.bool,
};
